import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


interface OwnProps {
    product: CartLineModel | ProductContextModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductImageStyles;
    showSmallImage?: boolean;
    showOverlay?: string;
    noRedirect?: boolean
}

type Props = OwnProps & HasHistory;

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
    imgOverlay?: ImgProps;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: 120px;
            width: 100%;
            object-fit: cover;
        `,
    },
    imgOverlay: {
        css: css`
            height: 120px;
            width: 100%;
            object-fit: cover;
            position: absolute;     
            z-index: 1;  
            background-color: #333333;
            opacity: 0.75;
            display: flex;
            align-items: center;
            justify-content: center;
            
            span {
                color: ${getColor("common.background")};
                font-weight: 700;
                font-size: 1.5rem;
            }
        `,
    },
};

const ProductImage = ({ product, onClick, extendedStyles, showSmallImage, showOverlay, noRedirect=false }: Props) => {
    const [styles] = useState(() => mergeToNew(productImageStyles, extendedStyles));

    let altText = "product" in product ? product.product.imageAltText : product.altText;
    if (!altText || altText === "") {
        altText = "product" in product ? product.product.productTitle : product.productName;
    }

    const imagePath =
        "product" in product
            ? showSmallImage
                ? product.product.smallImagePath || product.product.mediumImagePath
                : product.product.mediumImagePath || product.product.smallImagePath
            : product.smallImagePath;

    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";

    if(noRedirect) {
        return (
            <>          
                <Img {...styles.img} loading={loading} width="209" height="209" src={imagePath} altText={altText} />
                {showOverlay === 'true' && (
                    <StyledWrapper {...styles.imgOverlay}>
                        <Typography>{translate('Coming soon')}</Typography>
                    </StyledWrapper>
                )}
            </>
        )
    } 
        return (
            <Clickable
                {...styles.linkWrappingImage}
                href={productDetailPath}
                onClick={onClick}
                data-test-selector="productImage"
            >
                <Img {...styles.img} loading={loading} width="209" height="209" src={imagePath} altText={altText} />
            </Clickable>
        );
    

};

export default connect()(withHistory(ProductImage));
